import {useActions, useGetters, useMutators, useState} from './_default.js';
import {MAP_OBJECT_TYPE_EVENT} from "@/js/constants";
import EventPopup from "@/js/Components/MapPopup/EventPopup.vue";
import axios from "axios";
import {onlyKeys} from "@/js/helpers";
export default {
    namespaced: true,
    state: {
        ...useState(),
        name: MAP_OBJECT_TYPE_EVENT,
        listUrl: '/payload/paginated/sidebar/event',
        popupComponent: EventPopup,
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        load({ state, commit }, url) {
            return new Promise((resolve, reject) => {
                axios.get(url, { params: { search: state.filter.s }}).then((response) => {
                    response.data.data.forEach((event) => {
                        commit('updateOrAddToList', event);
                    });
                    state.pagination = onlyKeys(response.data, ['next_page_url']);
                    resolve(response);
                });
            });
        }
    },
}
